import { useChartUsery } from './hooks'
import { useChartData } from './hooks/useChartData'
import pluralize from 'pluralize'
import { useStatsPermission } from 'app/webview/pages/stats_profile/lib/hooks'
import { StatsProfileBox } from '../../../shared/stats_profile_box'
import { ReaderInsight } from '../../../shared/ReaderInsight'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { getName } from 'utils'
import capitalize from 'lodash/capitalize'
import { GenreStreamContent } from './GenreStreamContent'
import { useState } from 'react'
import { analytics } from 'segment_analytics'

export const GenreStream = () => {
  const [shouldFetch, setShouldFetch] = useState(false)
  const query = useChartUsery({ enabled: shouldFetch })
  const [yearStatus, stats, isSelfView] = useStats((s) => [
    s.yearStatus,
    s.stats,
    s.isSelfView,
  ])
  const { genres, isZeroState } = useChartData()
  const total = isZeroState ? 0 : genres.length
  const zeroState = isZeroState
  const { isStatsOwner, isPlusUser, isAndroid } = useStatsPermission()
  const id = 'genre-stream'
  const statsUserName = getName(stats?.user?.display_name)?.first
  const firstName = statsUserName ? capitalize(statsUserName) : ''

  if (!isPlusUser || isAndroid) return null

  const queryLoaded = shouldFetch && !query.isIdle && query.isFetched

  return (
    <StatsProfileBox
      id={id}
      data-testid={`stats-${id}`}
      onViewed={() => !shouldFetch && setShouldFetch(true)}
      text={{
        top: `${isSelfView ? 'You' : firstName} explored`,
        main: pluralize('genre', total, true),
        unit: '',
        infoText: (
          <>
            <b>How do you calculate genre breakdowns?</b>
            <br />
            We look at the genres for finished books in a given month and
            calculate the breakdown.
          </>
        ),
      }}
      textAnim={{
        trigger: 'data',
        loaded: queryLoaded,
      }}
      footer={
        queryLoaded && isStatsOwner && zeroState && yearStatus === 'current' ? (
          <ReaderInsight
            data-testid={`reader-insight-${id}`}
            label="How to get started"
            text="Add books to your Finished list, and make sure to add a Finished date. We’ll take it from there!"
          />
        ) : null
      }
      screenshot={{
        enabled: !zeroState && yearStatus === 'current',
        component: <GenreStreamContent skipAnim />,
        onClick: () =>
          analytics.events.stats.statsShareTap({ type: 'genre_stream' }),
      }}
    >
      <GenreStreamContent />
    </StatsProfileBox>
  )
}
